export { default as CalendarSolidIcon } from './CalendarSolidIcon';
